/** Base URL including `/api` suffix. */
export function getApiBase(): string {
  if (typeof window !== 'undefined' && typeof (window as Window & { VIP_MP_API_BASE?: string }).VIP_MP_API_BASE === 'string') {
    const runtimeBase = (window as Window & { VIP_MP_API_BASE?: string }).VIP_MP_API_BASE?.trim();
    if (runtimeBase) {
      return runtimeBase.replace(/\/+$/, '');
    }
  }

  const configured = process.env.REACT_APP_API_BASE?.trim();
  if (configured) {
    return configured.replace(/\/+$/, '');
  }

  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3001/api';
  }

  // In non-dev builds, default to same-origin `/api` for simple deployments.
  return `${window.location.origin}/api`;
}
